import doc                      from 'decorators/doc';
import model                    from 'decorators/model';
import { Blamable }             from 'helpers/traits';
import { Timestampable }        from 'helpers/traits';
import DirectoryPrivateApiModel from '../../abstracts/DirectoryPrivateApiModel';

@model.staticLabel(`Type d'entreprise`)
@model.urnResource('enterprise_type')
@doc.path('/enterprise_types/{?id}')
export default class EnterpriseTypeModel extends Blamable(Timestampable(DirectoryPrivateApiModel)) {
	public _filters: ModelFiltersExtended<{
		'hasSiren': boolean;
		'reference': DirectoryEnterpriseTypeReference;
	}> = {};

	public _sorts: ModelSortsExtended<{
		'hasSiren': string;
		'id': string;
		'label': string;
	}> = {};

	public static cacheDuration = 3600;

	@doc.boolean declare hasSiren: boolean;
	@doc.string declare label: string;
	@doc.string declare reference: DirectoryEnterpriseTypeReference;
}